import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';
import styled from 'styled-components';
//import moment from "moment-timezone";
import orderBy from 'lodash/orderBy';

import { changeLocation } from '../../api/Location';
//import { isSurveyFinished } from '../../api/Surveys';
import { getRequest } from '../../api/ApiService';
import Auth from '../../routes/Auth';

const Wrapper = styled.div`
  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

class StartPage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    if (Auth.getPosition() === 'Instructor') {
      const { rounds } = this.props;
      const finishedRounds = rounds.filter(i => (
        i.is_started === true &&
        i.is_finished === true
      ));

      /*getRequest(`${process.env.REACT_APP_API_URL}v2/forms/surveys/`)
        .then(res => {*/
          /*const surveys = res.body.results;
          const finishedSurveys = surveys.length
            ? surveys.filter(i => isSurveyFinished(i))
            : [];
          const lastFinishedSurvey =
            finishedSurveys.length > 0
              ? finishedSurveys[finishedSurveys.length - 1]
              : null;*/

          if (finishedRounds.length === 0) {
            /*if (lastFinishedSurvey) {
              changeLocation(`/instructor/peer-feedback?round=1`);
            } else {*/
              changeLocation(`/instructor/onboarding?round=1`);
            //}
          } else {
            const lastFinishedRound = finishedRounds[finishedRounds.length - 1];
            /*if (lastFinishedSurvey) {
              const lastFinishedRoundDate = moment(lastFinishedRound.end_date);
              const lastFinishedSurveyDate = moment(lastFinishedSurvey.end);

              if (lastFinishedRoundDate.isSame(lastFinishedSurveyDate) || lastFinishedSurveyDate.isAfter(lastFinishedRoundDate)) {
                changeLocation(`/instructor/peer-feedback?round=${lastFinishedRound.number}`);
              } else {
                changeLocation(`/instructor/performance-feedback?round=${lastFinishedRound.number}`);
              }
            } else {
              changeLocation(`/instructor/performance-feedback?round=${lastFinishedRound.number}`);
            }*/

            changeLocation(`/instructor/performance-feedback?round=${lastFinishedRound.number}`);
          }
        /*})
        .catch(err => { });*/
    } else {
      if (Auth.isPaid() === false) {
        this.setState({
          loaded: true,
        });
        return;
      }

      getRequest(`${process.env.REACT_APP_API_URL}game/rounds/`)
        .then(res => {
          const allRounds = orderBy(res.body, ['number'], ['asc']);
          const startedRounds = allRounds.filter(i => i.is_started === true);

          if (startedRounds.length === 0) {
            changeLocation('/onboarding');
            return;
          }

          const currentRound = startedRounds[startedRounds.length - 1];
          if (currentRound.is_finished === true || currentRound.should_be_finished === true) {
            changeLocation(`/performance-feedback?round=${currentRound.number}`);
            return;
          }

          if (currentRound.number === 1) {
            changeLocation(`/onboarding?round=${currentRound.number}`);
            return;
          }

          const courseId = Number(Auth.getCourseId());
          const gameId = Number(Auth.getGameId());
          const userId = Number(Auth.getUserId());
          const priorRound = currentRound.number - 1;

          getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/?game=${gameId}&course=${courseId}&user=${userId}&round_number=${priorRound}`)
            .then(res => {
              const visited = res.body.results
                .find(i => (
                  i.page === `${window.location.protocol}//${window.location.host}/performance-feedback/good-luck`
                ));

              if (!visited) {
                changeLocation(`/performance-feedback?round=${priorRound}`);
                window.location.reload();
              } else {
                changeLocation(`/onboarding?round=${currentRound.number}`);
              }
            })
            .catch(err => { });
        })
        .catch(err => { });
    }
  }

  render() {
    const { loaded } = this.state;

    return !loaded ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : <Wrapper />;
  }
}

export default StartPage;



// WEBPACK FOOTER //
// ./src/components/navigation/start.js